module.exports = __webpack_public_path__ + "5d5edcfe00cd5d87841edaf9efe4d5b4.png";